"use client"

import Link from "next/link"
import { useRef } from "react"
import { useIsMobile } from "@/hooks/use-is-mobile"

const BestSeller = ({ bestDataItems }) => {
  const { isMobile } = useIsMobile()

  const containerRef = useRef(null)
  let isDragging = false
  let startX
  let scrollLeft

  const handleMouseDown = (e) => {
    isDragging = true
    containerRef.current.style.cursor = "grabbing"
    containerRef.current.style.userSelect = "none" // 禁用文本选择
    startX = e.pageX - containerRef.current.offsetLeft
    scrollLeft = containerRef.current.scrollLeft
  }

  const handleMouseLeave = () => {
    isDragging = false
    containerRef.current.style.cursor = "grab"
    containerRef.current.style.userSelect = "" // 恢复文本选择
  }

  const handleMouseUp = () => {
    isDragging = false
    containerRef.current.style.cursor = "grab"
    containerRef.current.style.userSelect = "" // 恢复文本选择
  }

  const handleMouseMove = (e) => {
    if (!isDragging) return
    e.preventDefault()
    const x = e.pageX - containerRef.current.offsetLeft
    const walk = (x - startX) * 2 // 滚动速度

    containerRef.current.scrollLeft = scrollLeft - walk
  }

  return (
    <div className="mt-[60px] px-[17px] lg_px-0">
      <div className="mx-auto w-[1440px] max-w-full">
        <h2 className="mb-[30px] flex items-end justify-between font-poppins text-[22px] font-[600] leading-[1.4] text-title lg_text-[30px]">
          Shop Best Sellers
          <div>
            <Link
              href="/bird-feeders?sort_by=best_sellers"
              className="font-sans text-[16px] font-normal uppercase text-primary underline"
            >
              {isMobile ? "View All" : "View All Best Sellers"}
            </Link>
          </div>
        </h2>

        <div className="w-full">
          <div
            id="scroll-container"
            ref={containerRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            className="flex overflow-x-auto whitespace-nowrap pb-[30px]"
          >
            {bestDataItems &&
              bestDataItems?.map((product, index) => (
                <div
                  className="mr-[12px] w-[calc(50%-6px)] shrink-0 select-none lg_mr-[30px] lg_w-[320px]"
                  key={index}
                >
                  {product.component}
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default BestSeller
